import moment from "moment-timezone";

import {VisitTemplate} from "v2/api/Records";

export const apiVisitTemplate = (item) => {
  return new VisitTemplate({
    ...item,
    expectedDuration: item.expectedDuration && moment.duration(item.expectedDuration),
  });
};

export default {
  apiVisitTemplate,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/VisitTemplates.js
 **/